import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const StepWrapper = styled.div`
	background-color: ${({ isOpen }) => isOpen && 'var(--modal-bg-2)'};
	padding: 2.58rem;
	border-radius: ${({ isOpen }) => isOpen && 'var(--medium-border-radius)'};

	border-top: ${(props) => (props.hasBorder && !props.isOpen ? '1px solid var(--border-color)' : 'none')};

	margin-bottom: ${({ isOpen, extraPaddingBottom }) => isOpen && extraPaddingBottom && '2.58rem'};
	margin-top: ${({ isOpen, extraPaddingTop }) => isOpen && extraPaddingTop && '2.58rem'};

	& > .collapse-container {
		overflow: hidden;
	}
	@media ${Breakpoints.mobile} {
		padding: 2rem;
	}
`;

export const ProgressStep = styled.div`
	padding: 0 4rem;
	display: ${({ visible }) => (visible ? 'flex' : 'none')};
	margin-bottom: 1rem;
`;

export const IconWrapper = styled.div`
	width: 3rem;
`;

export const AccordionHeader = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;

	cursor: pointer;
`;

export const AccordionHeading = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 3rem max-content max-content;
	align-items: center;
	gap: 1rem;

	@media ${Breakpoints.tablet} {
		gap: 0.5rem;
	}
`;

export const CollapseContentWrapper = styled.div`
	padding: 0 0 0 4rem;
	display: grid;
	grid-template-areas: 'Description Gif' 'ActionButtons Gif';
	gap: 2rem;

	body[dir='rtl'] & {
		padding: 0 4rem 0 0;
	}

	@media ${Breakpoints.tablet} {
		grid-template-areas:
			'Description'
			'Gif'
			'ActionButtons';
		gap: 1rem;
	}
`;

export const DescriptionWrapper = styled.div`
	grid-area: Description;
	padding-top: 2rem;
	width: 70%;

	@media ${Breakpoints.tablet} {
		padding-top: 1rem;
		width: 100%;
	}
`;

export const ActionButtons = styled.div`
	grid-area: ActionButtons;
	display: grid;
	align-items: end;
	grid-template-columns: 20rem 20rem;
	gap: 1rem;
	padding-bottom: 1rem;

	@media ${Breakpoints.desktop} {
		grid-template-columns: 1fr;
	}
`;

export const StepPreview = styled.div`
	grid-area: Gif;
	display: grid;
	justify-self: end;
	width: 30rem;
	height: 17rem;

	@media ${Breakpoints.tablet} {
		justify-self: start;
		height: 50rem;
	}
`;
